import { useLayoutEffect } from 'react'
import { WOOFZ_CLUB_HOSTNAME } from 'root-constants'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

const COOKIEYES_WOOFZ_ACADEMY_PROD_ID = '058d8dccbf49d743ddce0b08'
const COOKIEYES_WOOFZ_CLUB_PROD_ID = '648ad5cdd4e7b134e8b25700fb678a91'

export const useInitCookieyesTag = (): void => {
  useLayoutEffect(() => {
    if (import.meta.env.CURRENT_ENV !== 'prod') {
      useZustandSessionStore.setState({
        cookieyesConsent: true,
        isDoNotSellInfoAvailable: false,
        isCookiePolicyAvailable: false,
      })
      return
    }

    if (document.getElementById('cookieyes')) return

    const { hostname } = window.location

    const currentCookieyesId =
      hostname === WOOFZ_CLUB_HOSTNAME
        ? COOKIEYES_WOOFZ_CLUB_PROD_ID
        : COOKIEYES_WOOFZ_ACADEMY_PROD_ID

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'cookieyes'
    script.src = `https://cdn-cookieyes.com/client_data/${currentCookieyesId}/script.js`
    document.head.appendChild(script)

    script.onload = () => {
      document.addEventListener('cookieyes_banner_load', (e: Event) => {
        const event = e as CustomEvent<any>

        if (event.detail?.activeLaw !== 'ccpa') {
          useZustandSessionStore.setState({
            cookieyesConsent: true,
          })

          if (event.detail.activeLaw === 'gdpr') {
            useZustandSessionStore.setState({
              isDoNotSellInfoAvailable: false,
              isCookiePolicyAvailable: true,
            })
          }

          return
        }

        if (!event.detail?.isUserActionCompleted) {
          document.body.classList.add('overlay')
        }

        useZustandSessionStore.setState({
          isCookiePolicyAvailable: false,
          isDoNotSellInfoAvailable: true,
          cookieyesConsent: event.detail?.isUserActionCompleted
            ? event.detail?.categories?.analytics
            : false,
        })

        const closeBtn = document.querySelector('.cky-banner-btn-close')

        closeBtn?.addEventListener('click', () => {
          document.body.classList.remove('overlay')
          useZustandSessionStore.setState({
            cookieyesConsent: true,
          })
        })
      })

      document.addEventListener('cookieyes_consent_update', (e: Event) => {
        const isCcpa = window?.getCkyConsent?.()?.activeLaw === 'ccpa'
        const isUserActionCompleted = window?.getCkyConsent?.()
          ?.isUserActionCompleted

        if (!isCcpa || !isUserActionCompleted) {
          return
        }

        const { detail } = e as CustomEvent<{ accepted: string[] }>

        useZustandSessionStore.setState({
          cookieyesConsent: detail?.accepted.includes('analytics'),
        })
        document.body.classList.remove('overlay')
      })
    }
  }, [])
}
